export default {
  shopLinks: [],
  loadingLinks: false,
};
